<template>
  <div v-if="isInViewDefined" id='socialwolvez_com_450x398_in_page_repeatable_responsive' style="text-align: center;" class="in-page-style">
  </div>
</template>

<script setup>

import {onMounted} from "vue";

const isInViewDefined = typeof inView !== 'undefined'

onMounted(() => {
  const randomiser = (Math.random() + 1).toString(36).substring(7);
  const element = document.querySelector('#socialwolvez_com_450x398_in_page_repeatable_responsive')
  if (!element) return

  const adID = element.id = "socialwolvez_com_450x398_in_page_repeatable_responsive-" + randomiser;

  if (!isInViewDefined) return

  inView('#' + adID).once('enter', (function () {
    if (typeof googletag === 'undefined') return

    googletag.cmd.push(function () {
      if (window.innerWidth > 1000) {
        googletag.defineSlot('/147246189,22901330980/socialwolvez.com_450x398_in_page_repeatable_desktop', [[300,250],[336,336],[336,320],[320,320],[300,300],[336,280],[320,250]], adID).addService(googletag.pubads());
      } else {
        googletag.defineSlot('/147246189,22901330980/socialwolvez.com_370x300_in_page_repeatable_mobile', [[300,250],[300,300],[336,280],[320,250],[370,300]], adID).addService(googletag.pubads());
      }
      googletag.display(adID);

      if (typeof stpd === 'undefined') return
      stpd.initializeAdUnit(adID);
    });
  }));
})

</script>

<style scoped>

</style>